import React, { Component } from 'react';
// import Modal from "../../../../../shared/modal";
import Modal from 'react-responsive-modal';
import { DERIVATIONS_REASONS } from '../../../../../../constants/app/inspection';
import TransformInspection from '../../../../../../lib/utils/transforms/inspection';
const closeSvg = <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" />
const ModalDerivation = ({ open = false, handleChangeDerivation = () => {}, handleClose, handleOk, derivationsSelected, reasonsDerivations }) => {

    return(
		<Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true}>
			<div className="col-md-12">
				<span className="h2 m20 ml10 mb10">Observar inspección</span>
				<div className="text-md--light m10">
					Por favor, indica el/los motivo(s) para derivar la inspección a suscripción.
				</div>
				<div className="row mt10">
					<div className="col-md-12">
						{
							DERIVATIONS_REASONS.map((derivation, index) => (
								<div key={index}>
									<input
										id={"derivation-"+ derivation.id}
										onChange={handleChangeDerivation.bind(this, {id: derivation.id, label: derivation.label})}
										type="checkbox"
                                        className="ui-form-control"
									/>
									<label for={"derivation-"+ derivation.id}>{derivation.label}</label>
								</div> 
							))
						}
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<button type="button" className="btn btn-outline-secondary mr10" onClick={handleClose}>Cancelar</button>
						<button type="button" className="btn btn-primary" onClick={handleOk}>Confirmar</button>
					</div>  
				</div>
			</div>
			
		</Modal>
	);
}
export default ModalDerivation;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/derivations/modal-derivations.js